(function(){
    'use strict';

    angular
    .module('appback')
    .controller('RegulatoryController', RegulatoryController)
 
    RegulatoryController.$inject = ["GenerallabService", "ProductosService","$http","$timeout","$uibModal", "$log", "$document","$sce","Upload"];
              
    function RegulatoryController(GenerallabService,ProductosService,$http,$timeout,$uibModal, $log, $document,$sce,Upload)
    {                         
        var vm = this;
        vm.generalLab = GenerallabService;
        vm.highlightedCol = null;
        vm.searchProduct = '';
        vm.searchCountry = '';

        vm.productos = window.initialData.productos || [];
        vm.paises = window.initialData.paises || [];
        vm.matrix = window.initialData.matrix || {};

        vm.isProductVisible = function(name) {
            if (!vm.searchProduct) return true;
            return name.toLowerCase().indexOf(vm.searchProduct.toLowerCase()) !== -1;
        };

        vm.isCountryVisible = function(name) {
            if (!vm.searchCountry) return true;
            return name.toLowerCase().indexOf(vm.searchCountry.toLowerCase()) !== -1;
        };

        vm.highlightCol = function(index) {
            vm.highlightedCol = index;
        };

        vm.unhighlightCol = function() {
            vm.highlightedCol = null;
        };

        vm.updatePriorityPais = function(pais) {
            if(pais.prioridad === null || pais.prioridad === undefined || pais.prioridad === ''){
                return;
            }
            console.log("updatePriorityPais", pais);
            ProductosService.updatePriorityPais(pais.id, pais.prioridad, function(data){
                if (data.code === 1) {
                   vm.paises.sort(function(a, b){
                        if(b.prioridad - a.prioridad !== 0){
                            return b.prioridad - a.prioridad;
                        }
                        return a.nombre.localeCompare(b.nombre);
                   });
                } else {
                    alert('Error al actualizar la prioridad');
                }
            });
        };

        vm.modalInstance = false;
        vm.openProductoPaisModal = function(producto, pais){
            ProductosService.getProductoPaisData(producto.id, pais.id, function(data){
                console.log("data", data);
                vm.modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal.title-top',
                    ariaDescribedBy: 'modal.body-top',
                    templateUrl: 'productopaismodal.html',
                    size: 'lg',
                    controller: function($scope){
                        $scope.statusId = data.status;
                        $scope.prioridad = data.prioridad || 0;
                        $scope.files = data.files;
                        $scope.producto = data.producto;
                        $scope.pais = data.pais;
                        $scope.modified = false;

                        
                        $scope.updateStatus = function(new_status_id){
                            console.log("changing status from " + $scope.statusId + " to " + new_status_id);
                            ProductosService.updateStatus(producto.id, pais.id, new_status_id, function(data){
                                if (data.code === 1) {
                                    $scope.statusId = new_status_id;
                                    $scope.modified = true;
                                    
                                    // Update main matrix immediately
                                    if(!vm.matrix[producto.id]) vm.matrix[producto.id] = {};
                                    if(!vm.matrix[producto.id][pais.id]) vm.matrix[producto.id][pais.id] = {};
                                    
                                    vm.matrix[producto.id][pais.id].estado = new_status_id;

                                } else {
                                    alert('Error al actualizar el estado');
                                }
                            });
                        }

                        $scope.togglePriority = function(){
                            var newPriority = ($scope.prioridad == 1) ? 0 : 1;
                            ProductosService.updatePriorityProductoPais(producto.id, pais.id, newPriority, function(data){
                                if(data.code === 1){
                                    $scope.prioridad = newPriority;
                                    $scope.modified = true;
                                    
                                    // Update main matrix immediately
                                    if(!vm.matrix[producto.id]) vm.matrix[producto.id] = {};
                                    if(!vm.matrix[producto.id][pais.id]) vm.matrix[producto.id][pais.id] = {};
                                    
                                    vm.matrix[producto.id][pais.id].prioridad = newPriority;

                                } else {
                                    alert('Error al actualizar la prioridad');
                                }
                            });
                        }


                        $scope.refrescarDocs = function(){
                            console.log("REFRESCANDO DOCS");
                            ProductosService.getProductoPaisData(producto.id, pais.id, function(data){
                                $scope.files = data.files;
                            })
                        }

                        $scope.closeModal = function() {
                            vm.modalInstance.close();
                        };

                    }
                });
            })
        }
    }
  
})();